import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

import { IUpdateChannelAttributeGroupRequestBody } from './types';

export const updateChannelAttributeGroup = async (
  productId: string,
  payload: IUpdateChannelAttributeGroupRequestBody,
  image: File | null | string,
  externalSystemId: string,
) => {
  const requestBody = new FormData();

  requestBody.append('data', JSON.stringify(payload));
  if (image instanceof File || image === null) {
    requestBody.append('files', image);
  }

  const response = await fetch(`${API_URL}/items/${productId}/rules/${externalSystemId}`, {
    method: 'PATCH',
    body: requestBody,
  });

  if (response.status !== Status.SUCCESS) {
    throw new Error('Something went wrong whilst editing channel attribute');
  }

  return response;
};
